<script setup lang="ts">
import VideoGrid from '@/components/VideoGrid.vue'
import type { VideoItem } from '@/types'

const props = withDefaults(
	defineProps<{
		videos: VideoItem[]
		columns: number
	}>(),
	{
		videos: () => [],
		columns: 2,
	},
)
</script>

<template>
	<VideoGrid :videos="props.videos" :columns="props.columns" />
</template>
